import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { onClickOutside } from '../../../js/global/clickoutside';

gsap.registerPlugin(ScrollTrigger)

export default class Header {
  constructor (el) {
    this.el = el
    this.burger = this.el.querySelector('.js-header-burger')
    this.menu = this.el.querySelector('.js-header-menu')
    this.lastScrollPosition = 0
    this.tel = this.el.querySelector('.js-dropdown-toggler')
    this.dropBtn = this.el.querySelectorAll('.js-header-dropdown')
    this.dropMenu = this.el.querySelectorAll('.header__sublist')
    this.backlink = this.el.querySelectorAll('.js-header-backlink')

    this.dropdowns = this.el.querySelectorAll('.js-dropdown')

    this.desktopMenu = document.querySelector('.js-menu')
    this.menuToggler = this.el.querySelector('.header__item.js-header-dropdown:not(.header__item--drop-inside)')
    this.dropToggler = this.el.querySelectorAll('.header__item.header__item--drop-inside')
    
    this.langSwitcher = this.el.querySelector('.header__lang-switcher')
    this.langSwitcherItems = this.langSwitcher.querySelectorAll('.header__lang-switcher-item')

    this.langSwitcherMobile = this.el.querySelector('.js-d-lang')
    this.langSwitcherBtnMobile = this.langSwitcherMobile?.querySelector('.d-lang__trigger')

    this.toggleHandler = (e) => this.toggle(e)
    this.scrollHandler = (e) => this.onScroll(e)
    this.resizeHandler = (e) => this.onResize(e)
    this.langSwitcherMouseEnterHandler = () => this.showLangSwitcher()
    this.langSwitcherMouseLeaveHandler = () => this.hideLangSwitcher()

    this.body = document.body

    this.timeout = null
    this.timeout2 = null
    this.timeout3 = null

    this.delay = 300
    this.isMenuOpen = false
  }

  init () {
    this.initEvents()
    this.onResize()

    onClickOutside(this.langSwitcherMobile, () => {
      this.hideLangSwitcherMobile()
    })
  }

  initEvents () {

    this.desktopMenu.addEventListener('mouseenter', e => this.onMenuMouseover())
    this.desktopMenu.addEventListener('mouseleave', e => this.onMenuMouseleave())
    this.menuToggler.addEventListener('mouseenter', e => this.onItemMouseover(e))
    this.menuToggler.addEventListener('mouseleave', e => this.onItemMouseleave(e))
    this.dropToggler.forEach(el => el.addEventListener('mouseenter', e => this.onDropItemMouseover(e)))
    this.dropBtn.forEach(el => {
      el.addEventListener('click', e => this.showDropMenu(e))
    });
    this.backlink.forEach(el => {
      el.addEventListener('click', e => this.hideDropMenu(e))
    })
    this.burger.addEventListener('click', this.toggleHandler)
    this.tel.addEventListener('click', e => this.onTelClick())
    this.langSwitcher.addEventListener('mouseenter', this.langSwitcherMouseEnterHandler)
    this.langSwitcher.addEventListener('mouseleave', this.langSwitcherMouseLeaveHandler)
    this.langSwitcherBtnMobile?.addEventListener('click', e => this.showLangSwitcherMobile(e))
    window.addEventListener('scroll', this.scrollHandler, {passive: true})
    window.addEventListener('resize', e => this.onResize())
  }

  showLangSwitcherMobile (e) {
    e.preventDefault()

    this.langSwitcherMobile?.classList.add('active')
  }
  
  hideLangSwitcherMobile () {
    this.langSwitcherMobile?.classList.remove('active')
  }

  showLangSwitcher () {
    const itemHeight = this.langSwitcherItems[0]?.clientHeight
    const style = window.getComputedStyle(this.langSwitcher)
    const offset = parseFloat(style.paddingTop) * 2

    gsap.to(this.langSwitcher, {
      duration: 0.3,
      ease: 'ease',
      height: `${itemHeight * this.langSwitcherItems.length + offset}`
    })
  }

  hideLangSwitcher () {
    const itemHeight = this.langSwitcherItems[0]?.clientHeight
    const style = window.getComputedStyle(this.langSwitcher)
    const offset = parseFloat(style.paddingTop) * 2

    gsap.to(this.langSwitcher, {
      duration: 0.3,
      ease: 'ease',
      height: `${itemHeight + offset}`
    })
  }

  onResize () {
    if (window.innerWidth < 1280) {
      
    } else {
      this.dropMenu.forEach(el => el.classList.remove('active'))
      this.burger.classList.remove('active')
      this.el.classList.remove('open')
      document.body.classList.remove('block-scroll')
    }

    this.hideLangSwitcher()
  }

  hideDropMenu (e) {
    e.preventDefault()
    const target = e.currentTarget
    const menu = target.closest('.header__sublist')

    menu.classList.remove('active')
  }

  showDropMenu(e) {

    if (window.innerWidth > 1279) {
      return;
    }

    const target = e.currentTarget

    if ( ( !$('.js-header-backlink').is(e.target) && $('.js-header-backlink').has(e.target).length === 0 ) ) {
      const menu = target.querySelectorAll('.header__sublist')[0]
      menu.classList.add('active')
    }

  }

  onTelClick () {
    this.el.classList.toggle('tel-open')
    this.burger.classList.remove('active')
    this.el.classList.remove('open')
    document.body.classList.remove('block-scroll')
  }

  onScroll (e) {

    const currentScrollPosition = window.scrollY

    if (currentScrollPosition > 50 && (currentScrollPosition > this.lastScrollPosition)) {
      this.el.classList.add('collapsed')
    } else {
      this.el.classList.remove('collapsed')
    }

    this.lastScrollPosition = currentScrollPosition <= 0 ? 0 : currentScrollPosition

  }

  toggle (e) {
    e.preventDefault()
    if (this.el.classList.contains('open')) {
      this.dropMenu.forEach(el => el.classList.remove('active'))
    }
    this.burger.classList.toggle('active')
    this.el.classList.toggle('open')
    document.body.classList.toggle('block-scroll')
  }

  onDropItemMouseover (e) {
    if (window.innerWidth < 1280) return;
    clearTimeout(this.timeout3)
    clearTimeout(this.timeout)
    clearTimeout(this.timeout2)
    
    this.dropdowns.forEach(el => el.classList.remove('open'))
    this.isMenuOpen = true
    this.el.classList.add('fixed')
    this.delay = 0
    this.closeMenu()
    this.unsetActiveLink()
  }

  onItemMouseover (e) {
    console.log('over')
    if (window.innerWidth < 1280) return;
    clearTimeout(this.timeout3)
    clearTimeout(this.timeout2)
    this.menuToggler.classList.add('active')
    
    this.timeout = setTimeout( () => {
      this.dropdowns.forEach(el => el.classList.remove('open'))
      this.isMenuOpen = true
      this.el.classList.add('fixed')
      this.delay = 0
      this.desktopMenu.classList.add('active')
    }, this.delay )
  }

  onItemMouseleave (e) {
    console.log('leave')
    if (window.innerWidth < 1280) return;
    clearTimeout(this.timeout)
    this.timeout2 = setTimeout(() => {
      this.closeMenu()
    }, 300)
    this.timeout3 = setTimeout(() => {
      this.unsetActiveLink()
    }, 300)
  }

  onMenuMouseover () {
    if (window.innerWidth < 1280) return;
    clearTimeout(this.timeout2)
    clearTimeout(this.timeout3)
  }
  
  onMenuMouseleave () {
    if (window.innerWidth < 1280) return;
    this.timeout2 = setTimeout(() => {
      this.closeMenu()
      this.unsetActiveLink()
    }, 300)
  }

  closeMenu () {
    this.hideLangSwitcherMobile()
    this.el.classList.remove('fixed')
    this.desktopMenu.classList.remove('active')
    this.isMenuOpen = false
    this.delay = 300
    
  }

  unsetActiveLink () {
    this.menuToggler.classList.remove('active')
  }

}
